import { useStaticQuery, graphql } from 'gatsby';

import type { IPostFilterPost, ITermNode } from '@klaviyo-mkt/components/organisms/post-filter/types';

const useResourcesQuery = () => {
  const query = useStaticQuery(graphql`
    query MyResourcesQuery {
    allWpResource {
      nodes {
        date
        featured {
          featuredPostImage {
            altText
            mediaDetails {
              height
              width
            }
            sizes
            sourceUrl
            srcSet
          }
        }
        uri
        title
        excerpt
        resourceCategories {
          nodes {
            name
            nodeType
            slug
          }
        }
        resourceCollections {
          nodes {
            name
            nodeType
            slug
          }
        }
        resourceStages {
          nodes {
            name
            nodeType
            slug
          }
        }
        resourceTopics {
          nodes {
            name
            nodeType
            slug
          }
        }
      }
    }
  }
`);
  return query.allWpResource.nodes.map((node: IPostFilterPost) => {
    node.filters = [
      ...node?.resourceCategories?.nodes || [] as ITermNode[],
      ...node?.resourceCollections?.nodes || [] as ITermNode[],
      ...node?.resourceStages?.nodes || [] as ITermNode[],
      ...node?.resourceTopics?.nodes || [] as ITermNode[],
    ];
    return node;
  });
};

export default useResourcesQuery;
